/* eslint-disable no-eval */
import alertUtils from './alertUtils'
import moduleUtils from './moduleUtils'
import formUtils from './formUtils'
import customApi from '../components/api/customApi'
/**
 * 事件工具
 */
export default class eventUtils {
  /**
   * 触发事件
   * @param widget  当前选中对象
   * @param dataList 组件列表
   * @param models  值对象
   * @param eventConfig  事件参数配置
   */
  static eventStart(widget, dataList, models, eventConfig) {
    if (widget && dataList) {
      if (
        widget.eventOptions &&
        widget.eventOptions.eventObj &&
        widget.eventOptions.eventObj.length > 0
      ) {
        const eventObj = widget.eventOptions.eventObj
        for (let i = 0; i < eventObj.length; i++) {
          // 循环该 元素 涵盖的所有事件
          if (eventObj[i]) {
            this.eventListHandle(
              eventObj[i].eventList,
              dataList,
              eventObj[i].functions,
              models,
              eventConfig
            )
          }
        }
      }
    }
  }

  /**
   *  事件开始迭代
   * @param objList  条件列表
   * @param dataList  组件列表
   * @param functions  事件类型
   * @param models  值对象
   * @param eventConfig  事件参数配置
   */
  static eventListHandle(eventList, dataList, functions, models, eventConfig) {
    if (eventList && dataList && functions) {
      let needTrigger = false // 是否会触发事件
      for (let i = 0; i < eventList.length; i++) {
        if (eventList[i] && eventList[i].func) {
          needTrigger = this.moreConditionJudge(eventList[i], models)
          if (needTrigger) {
            if (functions === 'hiddenDom') {
              // 隐藏组件
              this.hiddenDom(eventList[i], dataList, models)
            } else if (functions === 'cascadeDom') {
              // 级联
              this.cascadeDom(eventList[i], models)
            } else if (functions === 'alertPage') {
              // 弹窗事件
              this.alertPage(eventList[i], eventConfig)
            } else if (functions === 'disabledDom') {
              // 禁用组件事件
              this.disabledDom(eventList[i], dataList)
            }
          }
        }
      }
    }
  }

  /**
   *  子表单触发事件
   * @param widget
   * @param lineRow
   * @param models
   * @param eventConfig
   */
  static sonEventStart(widget, lineRow, models, eventConfig) {
    if (widget && lineRow) {
      if (
        widget.eventOptions &&
        widget.eventOptions.eventObj &&
        widget.eventOptions.eventObj.length > 0
      ) {
        const eventObj = widget.eventOptions.eventObj
        for (let i = 0; i < eventObj.length; i++) {
          // 循环该 元素 涵盖的所有事件
          if (eventObj[i]) {
            this.sonEventListHandle(
              eventObj[i].eventList,
              lineRow,
              eventObj[i].functions,
              models,
              eventConfig
            )
          }
        }
      }
    }
  }

  /**
   *  子表单事件开始迭代
   * @param objList  条件列表
   * @param lineRow  子表单行数据情况
   * @param functions  事件类型
   * @param models  值对象
   * @param eventConfig  事件参数配置
   */
  static sonEventListHandle(objList, lineRow, functions, models, eventConfig) {
    if (objList && lineRow && functions) {
      let needTrigger = false // 是否会触发事件
      for (let i = 0; i < objList.length; i++) {
        if (objList[i] && objList[i].func) {
          needTrigger = this.moreConditionJudge(objList[i], models)
          if (needTrigger) {
            if (functions === 'hiddenDom') {
              // 隐藏组件
              this.sonHiddenDom(objList[i], lineRow, models)
            } else if (functions === 'cascadeDom') {
              // 级联
              this.cascadeDom(objList[i], models)
            } else if (functions === 'alertPage') {
              // 弹窗事件
              this.alertPage(objList[i], eventConfig)
            } else if (functions === 'disabledDom') {
              // 禁用组件事件
              this.sonDisabledDom(objList[i], lineRow)
            }
          }
        }
      }
    }
  }

  /**
   *  隐藏组件
   * @param obj  条件
   * @param dataList  组件列表
   */
  static hiddenDom(obj, dataList, models) {
    if (obj.func.hide && obj.func.hide.length > 0) {
      moduleUtils.hiddenShowDomList(obj.func.hide, 'hidden', dataList, models)
    }
    if (obj.func.show && obj.func.show.length > 0) {
      moduleUtils.hiddenShowDomList(obj.func.show, 'show', dataList, models)
    }
  }

  /**
   *  子表单隐藏组件
   * @param obj  条件
   * @param lineRow  子表单行数据情况
   */
  static sonHiddenDom(obj, lineRow, models) {
    if (obj.func.hide && obj.func.hide.length > 0) {
      moduleUtils.sonHiddenShowDomList(obj.func.hide, 'hidden', lineRow, models)
    }
    if (obj.func.show && obj.func.show.length > 0) {
      moduleUtils.sonHiddenShowDomList(obj.func.show, 'show', lineRow, models)
    }
  }

  /**
   *  禁用组件
   * @param obj  条件
   * @param dataList  组件列表
   */
  static disabledDom(obj, dataList) {
    if (obj.func.disabled && obj.func.disabled.length > 0) {
      moduleUtils.disabledDomList(obj.func.disabled, 'disabled', dataList)
    }
    if (obj.func.undisabled && obj.func.undisabled.length > 0) {
      moduleUtils.disabledDomList(obj.func.undisabled, 'undisabled', dataList)
    }
  }

  /**
   *  禁用组件
   * @param obj  条件
   * @param dataList  组件列表
   */
  static sonDisabledDom(obj, lineRow) {
    if (obj.func.disabled && obj.func.disabled.length > 0) {
      moduleUtils.sonDisabledDomList(obj.func.disabled, 'disabled', lineRow)
    }
    if (obj.func.undisabled && obj.func.undisabled.length > 0) {
      moduleUtils.sonDisabledDomList(obj.func.undisabled, 'undisabled', lineRow)
    }
  }

  /**
   *  组件级联
   * @param obj  条件
   * @param models  组件值
   */
  static cascadeDom(obj, models) {
    let result = null
    if ((obj.func && obj.func.url) || obj.isSetUrl) {
      // 通过接口去设置级联数据
      customApi
        .requestInterface(obj.func.url, null)
        .then(response => {
          if (response) {
            result = response
            this.cascadeUrlSetValue(result, obj, models)
          }
        })
        .catch(() => {
          alertUtils.alertError('级联接口数据查询错误', true)
        })
    } else {
      // 不调用接口，直接设置值给对象
      try {
        this.cascadeSetValue(obj, models)
      } catch (e) {
        console.log('级联直接设置值', e)
        alertUtils.alertError('级联直接设置值错误', true)
      }
    }
  }

  /**
   *  级联直接设置值 不通过接口
   * @param obj
   * @param dataList
   * @param models
   */
  static cascadeSetValue(obj, models) {
    if (obj && obj.cascadeList && obj.cascadeList.length > 0) {
      obj.cascadeList.forEach(function (item) {
        moduleUtils.setValueToModels(null, item.field, item.value, models)
      })
    }
  }

  /**
   *  通过接口级联设置值
   * @param result
   * @param obj
   * @param dataList
   * @param models
   */
  static cascadeUrlSetValue(result, obj, models) {
    if (obj && obj.cascadeList && obj.cascadeList.length > 0) {
      const data = eval(
        'result' + (obj.func.paramFormat ? '.' + obj.func.paramFormat : '')
      )
      if (data) {
        if (!(data instanceof Array)) {
          // 不是数组接者往下走
          obj.cascadeList.forEach(function (item) {
            moduleUtils.setValueToModels(
              null,
              item.field,
              data[item.dbField],
              models
            )
          })
        }
      }
    }
  }

  /**
   *  弹窗
   * @param obj  条件对象
   * @param eventConfig  事件参数配置
   */
  static alertPage(obj, eventConfig) {
    if (obj.func.alert) {
      eventConfig.alertConfig.alertHtml = obj.func.alert
      eventConfig.alertConfig.isShow = true
    } else {
      eventConfig.alertConfig.alertHtml = ''
    }
  }

  /**
   * 多条件 验证是否成功
   * @param objList
   * @param models
   */
  static moreConditionJudge(objList, models) {
    const $this = this
    if (
      typeof objList.condition !== 'undefined' &&
      objList.condition !== null &&
      objList.condition.length > 0
    ) {
      const condition = objList.condition
      let flags = ''
      condition.forEach(function (item) {
        let boo = false
        if (formUtils.isNull(item.field)) {
          boo = true
        } else if (formUtils.isNotNull(item.expression)) {
          boo = $this.conditionJudge(item, models) // 满足条件
        }
        flags += boo + ' ' + item.relation + ' '
      })
      if (flags.endsWith('&& ') || flags.endsWith('|| ')) {
        flags = flags.substr(0, flags.length - 3)
      }
      return eval(flags)
    } else {
      let boo = true
      if (typeof objList.field !== 'undefined') {
        if (formUtils.isNull(objList.field)) {
          boo = true
        } else if (formUtils.isNotNull(objList.expression)) {
          boo = $this.conditionJudge(objList, models) // 满足条件
        }
      }
      return boo
    }
  }

  /**
   *  查看是否满足事件触发条件
   * @param obj
   * @param models
   * @returns {boolean}
   */
  static conditionJudge(obj, models) {
    const retObj = moduleUtils.getValueFromModels(null, obj.field, models)
    if (retObj.status === '500') {
      // 表示获取成功
      alertUtils.alertError(
        '请联系管理员，' + obj.field + '字段事件是否存在异常',
        true
      )
      return false
    }
    if (obj.expression === 'notnull') {
      if (retObj.value) {
        return true
      }
    } else if (obj.expression === 'isnull') {
      if (!retObj.value || formUtils.isNull(retObj.value)) {
        return true
      }
    } else {
      if (!retObj.value) {
        retObj.value = ''
      }
      if (formUtils.isNotNull(obj.value)) {
        return this.expressionCount(obj.value, obj.expression, retObj.value)
      } else {
        return this.expressionCount('', obj.expression, retObj.value)
      }
    }
  }

  /**
   * 计算条件表达式是否成立
   * @param value
   * @param expression
   * @param retValue
   * @returns {boolean}
   */
  static expressionCount(value, expression, retValue) {
    if (expression === '=') {
      if (value === retValue) {
        return true
      }
    } else if (expression === '!=') {
      if (value !== retValue) {
        return true
      }
    } else if (expression === '>') {
      if (Number(retValue) > Number(value)) {
        return true
      }
    } else if (expression === '>=') {
      if (Number(retValue) >= Number(value)) {
        return true
      }
    } else if (expression === '<') {
      if (Number(retValue) < Number(value)) {
        return true
      }
    } else if (expression === '<=') {
      if (Number(retValue) <= Number(value)) {
        return true
      }
    } else if (expression === 'include') {
      // 包含
      if (JSON.stringify(retValue).indexOf(value) !== -1) {
        return true
      }
    } else if (expression === 'unInclude') {
      // 不包含
      if (JSON.stringify(retValue).indexOf(value) === -1) {
        return true
      }
    }
    return false
  }
}
